<div class="tab-header">
  @for(tab of tabs; track tab; let i = $index){
  <button (click)="selectTab(i)" [class.active]="i === activeTabIndex">
    {{ tab.label }}
  </button>
  }
</div>

<div class="tab-body">
  @if(tabs.length){
  <ng-container>
    <ng-container *ngTemplateOutlet="tabs.toArray()[activeTabIndex].template"></ng-container>
  </ng-container>
  }
</div>
